export const brand = {
  name: "MOKA",
  tagline: "The Digital Operating System for Education",
  descriptor: "MOKA School Inf — one connected platform for payments, communication, finance, and digital services across the entire education ecosystem.",
  city: "Johannesburg",
  country: "South Africa",
  company: "MOKA",
  domain: "mokasi.co.za",
  logoUrl: "",
};

export const subBrands = [
  { name: "MOKA Pay", desc: "Payments" },
  { name: "MOKA Wallet", desc: "Digital wallets" },
  { name: "MOKA Market", desc: "School marketplace" },
  { name: "MOKA Finance", desc: "Billing & reconciliation" },
  { name: "MOKA Insights", desc: "Analytics & reporting" },
  { name: "MOKA Connect", desc: "Parent & school communication" },
  { name: "MOKA API", desc: "Developer platform" },
];
